import "ekko-lightbox/dist/ekko-lightbox.js";

export default {
  init() {
    $(document).on(
      "click",
      '[data-toggle="lightbox"]',
      function(event) {
        event.preventDefault();
        $(this).ekkoLightbox({
          alwaysShowClose: true,
        });
      }
    );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js